import { setRegisteredData } from "./registered-data";

$('.contact-form').on('submit-success', function(event, data, xhr) {
    event.submitSuccessCondition(xhr.status == 201 && data.status == 'OK');

    $('#modal-form-contact').modal('show');
});